import React from 'react';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ReturnedItemsListDetailTemplate = ({ store, store: { tableData, data, loading } }) => {
	if (loading) return null;
	return (
		<React.Fragment>
			<BaasicTable
				{...{
					tableData,
					store,
				}}
				data={data.slice()}
			/>
		</React.Fragment>
	);
};
export default defaultTemplate(ReturnedItemsListDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ReturnedItemsListDetailTemplate.jsx